import React from 'react'
import BulletedList from '../../../components/AgGrid/renderers/BulletedList'

const PropertyUnitBillingPartitionRenderer = (props) => {
  const { value } = props
  return (
    <BulletedList>
      {value.map((v) => (
        <li key={v.name}>{v.name}</li>
      ))}
    </BulletedList>
  )
}

export default PropertyUnitBillingPartitionRenderer
